import React from 'react';
import usePubNubVisitors from '../../hooks/usePubNubVisitors';
import { motion } from 'framer-motion';
import { useChat } from '../../modules/ChatPane';
import './style.scss';

interface VisitorAwarenessProps {
  room: string;
  showing: boolean;
}

const VisitorAwareness: React.FC<VisitorAwarenessProps> = ({ room, showing }) => {
  const [visitors] = usePubNubVisitors(room, true);

  const {
    context: { viewUser, getImgSrc },
  } = useChat();

  return (
    <motion.div className={`pubnub_users`} variants={messagesVariants} animate={showing ? `visible` : `hidden`}>
      {visitors.map(visitor => (
        <div
          key={visitor.ChatRoom}
          className={`user_list_user`}
          onClick={e => {
            viewUser(visitor);
          }}
        >
          <div
            className={`user_list_avatar`}
            style={{
              backgroundImage: `url(${getImgSrc(visitor.Avatar)})`,
            }}
          />
          <div className={`user_name`}>
            {visitor.Firstname} {visitor.Lastname}
          </div>
        </div>
      ))}
    </motion.div>
  );
};

const messagesVariants = {
  hidden: {
    opacity: 0,
    display: 'none',
  },
  visible: {
    opacity: 1,
    display: 'flex',
  },
};

export default VisitorAwareness;
